import apiClient from '../../../services/apiClient'
import { adminPermissionPresets } from '../adminConfig'

export function UserManager({ apiToken, rows = [], onRefresh }) {
  const updateUser = async (row, payload, message) => {
    if (!apiToken || !row.rawId) return

    try {
      await apiClient.updateUser(apiToken, row.rawId, payload)
      await onRefresh?.(message)
    } catch (error) {
      await onRefresh?.(error.message || 'User update failed')
    }
  }

  return (
    <section className="tactical-card obc-admin__builder">
      <div className="obc-admin__panel-head">
        <div>
          <h2>User Manager</h2>
          <span>Bidder verification, account status, payment readiness, and risk controls</span>
        </div>
      </div>
      <div className="obc-order-admin-grid">
        {rows.map((row) => (
          <article key={row.rawId || row.user}>
            <div>
              <strong>{row.user}</strong>
              <span>{row.role} / {row.payment}</span>
              <small>Status: {row.status || 'active'} / Risk: {row.risk}</small>
              <small>Permissions: {row.permissions}</small>
            </div>
            <div className="obc-consignment-admin-actions">
              <button type="button" onClick={() => updateUser(row, { verifiedBidder: true }, 'Bidder verified')}>Verify</button>
              <button type="button" onClick={() => updateUser(row, { verifiedBidder: false }, 'Bidder verification removed')}>Unverify</button>
              <button type="button" onClick={() => updateUser(row, { status: 'suspended' }, 'User suspended')}>Suspend</button>
              <button type="button" onClick={() => updateUser(row, { status: 'active' }, 'User reactivated')}>Reactivate</button>
              {row.rawRole === 'admin' ? (
                <>
                  <button type="button" onClick={() => updateUser(row, { adminPermissions: adminPermissionPresets.full }, 'Admin granted full access')}>Full Access</button>
                  <button type="button" onClick={() => updateUser(row, { adminPermissions: adminPermissionPresets.ops }, 'Admin granted ops access')}>Ops Access</button>
                  <button type="button" onClick={() => updateUser(row, { adminPermissions: adminPermissionPresets.reports }, 'Admin limited to reports')}>Reports Only</button>
                </>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export function AdminUsersModule({ apiToken, userRows, onRefresh }) {
  return <UserManager apiToken={apiToken} rows={userRows} onRefresh={onRefresh} />
}
